import {Avatar} from '@/components/ui/avatar/Avatar'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {AgendaButtonFilterSelection} from '@/features/agenda/components/agenda-button-filter-selection/AgendaButtonFilterSelection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaSidebarCard} from '@/features/agenda/components/agenda-sidebar-card/AgendaSidebarCard'
import {useTranslation} from '@/translations/i18n'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {StyledAgendaSidebarViewContent} from '@/features/agenda/components/agenda-sidebar-view-card/style'
import {AvailableDatesButton} from '@/features/agenda/components/available-dates-button/AvailableDatesButton'
import {Divider} from '@/components/ui/divider/Divider'
import {useAgendaCategoryCustom} from '@/features/agenda/hooks/useAgendaCategoryCustom'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {AgendaSidebarCardLoader} from '@/features/agenda/components/agenda-sidebar-card/AgendaSidebarCardLoader'

export const AgendaSubjectSelection = ({target}: {target: 'patients' | 'users'}) => {
    const {t} = useTranslation()
    const {
        searchParams: {category, specializationIds, subjectIds},
        isSubjectSelected,
        setSearchParams
    } = useAgendaSearchParams()

    const {subjects, isLoading} = useAgendaCategoryCustom()

    if (!subjects || category == 'team' || !subjects[0]?.id || (specializationIds && specializationIds.length > 0))
        return null

    const handleClearSubjects = () => {
        setSearchParams({
            subjectIds: [],
            category: undefined
        })
    }

    const handleRemoveSubject = (subjectId: string) => {
        const newSubjectIds = subjectIds?.filter(id => id !== subjectId)
        setSearchParams({
            subjectIds: newSubjectIds,
            category: newSubjectIds && newSubjectIds.length > 0 ? 'custom' : undefined
        })
    }

    if (subjects.length == 0 && isLoading) return <AgendaSidebarCardLoader title={t('commons:loading')} />

    return (
        <AgendaSidebarCard
            title={target == 'patients' ? t('agenda:selected_patients') : t('agenda:selected_operators')}
            onRemove={handleClearSubjects}
        >
            <ScrollArea scrollbar={<Scrollbar />} style={{maxHeight: '400px', width: '100%'}}>
                <StyledAgendaSidebarViewContent direction="column" gap={2} fullWidth>
                    {subjects.map(
                        subject =>
                            subject.fullName && (
                                <AgendaButtonFilterSelection
                                    key={subject.id}
                                    isSelected={isSubjectSelected(subject.id)}
                                    onClick={() => handleRemoveSubject(subject.id)}
                                >
                                    <Flexbox align="center" gap={2} fullWidth justify="space-between">
                                        <Flexbox align="center" gap={2}>
                                            <Avatar name={subject.fullName} size={'xs'} />
                                            <p>{subject.fullName}</p>
                                        </Flexbox>
                                        <XCloseIcon size={16} />
                                    </Flexbox>
                                </AgendaButtonFilterSelection>
                            )
                    )}
                    {isLoading && <Skeleton width={`100%`} height={32} />}
                </StyledAgendaSidebarViewContent>
            </ScrollArea>
            {target == 'users' && (
                <>
                    <Divider direction="horizontal" />
                    <AvailableDatesButton />
                </>
            )}
        </AgendaSidebarCard>
    )
}
